/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiDraftReferenceType } from './InternalApiDraftReferenceType';
import {
    InternalApiDraftReferenceTypeFromJSON,
    InternalApiDraftReferenceTypeFromJSONTyped,
    InternalApiDraftReferenceTypeToJSON,
    InternalApiDraftReferenceTypeToJSONTyped,
} from './InternalApiDraftReferenceType';

/**
 * Request to create a new draft note
 * @export
 * @interface InternalApiCreateNoteDraft
 */
export interface InternalApiCreateNoteDraft {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCreateNoteDraft
     */
    referenceId: number;
    /**
     * 
     * @type {InternalApiDraftReferenceType}
     * @memberof InternalApiCreateNoteDraft
     */
    referenceType: InternalApiDraftReferenceType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateNoteDraft
     */
    content: string;
}



/**
 * Check if a given object implements the InternalApiCreateNoteDraft interface.
 */
export function instanceOfInternalApiCreateNoteDraft(value: object): value is InternalApiCreateNoteDraft {
    if (!('referenceId' in value) || value['referenceId'] === undefined) return false;
    if (!('referenceType' in value) || value['referenceType'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCreateNoteDraftFromJSON(json: any): InternalApiCreateNoteDraft {
    return InternalApiCreateNoteDraftFromJSONTyped(json, false);
}

export function InternalApiCreateNoteDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateNoteDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'referenceId': json['referenceId'],
        'referenceType': InternalApiDraftReferenceTypeFromJSON(json['referenceType']),
        'content': json['content'],
    };
}

export function InternalApiCreateNoteDraftToJSON(json: any): InternalApiCreateNoteDraft {
    return InternalApiCreateNoteDraftToJSONTyped(json, false);
}

export function InternalApiCreateNoteDraftToJSONTyped(value?: InternalApiCreateNoteDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referenceId': value['referenceId'],
        'referenceType': InternalApiDraftReferenceTypeToJSON(value['referenceType']),
        'content': value['content'],
    };
}

